import { Curtains } from 'curtainsjs';
import Preloader, { firstTextureGroup, lastTextureGroup } from './Preloader';
import Plane from './Plane';

export default class VideoPlane {
	constructor() {
		this.curtains = new Curtains({
			container: 'canvas',
			alpha: true,
			pixelRatio: Math.min(2.0, window.devicePixelRatio), // limit pixel ratio for performance
		});

		this.firstGroupLoaded = false;
		this.canvasElement = document.getElementById('canvas');
		this.planeParents = [...document.querySelectorAll('[data-plane-parent]')];
		this.planeElements = this.planeParents.map(planeEl => planeEl.querySelector('[data-plane]'));

		if (!this.curtains.gl) return;

		this.preloader = new Preloader({ curtains: this.curtains });

		this.init();
	}

	init() {
		const waitForTexture = this.curtains.nextRender(() => {
			const textures = Object.values(window.TEXTURES);
			if (textures.length === firstTextureGroup.length && !this.firstGroupLoaded) {
				// textures are ready, stop executing the callback
				this.createInitialPlanes();
				this.canvasElement.classList.add('active');
				this.preloader.fetchRest();
				this.firstGroupLoaded = true;
			}

			if (textures.length === firstTextureGroup.length + lastTextureGroup.length) {
				waitForTexture.keep = false;
				this.createOtherPlanes();
			}
		}, true);
	}

	createInitialPlanes() {
		this.planes = this.planeElements.slice(0, 2).map((planeEl, i) => {
			const planeParentEl = this.planeParents[i];
			const groupName = planeParentEl.getAttribute('data-texture-group');

			return new Plane({
				curtains: this.curtains,
				planeEl,
				textures: firstTextureGroup,
				planeParentEl,
				groupName,
			});
		});
	}

	createOtherPlanes() {
		this.planeElements.slice(2, this.planeElements.length).map((planeEl, i) => {
			const planeParentEl = this.planeParents[i + 2];
			const groupName = planeParentEl.getAttribute('data-texture-group');

			return new Plane({
				curtains: this.curtains,
				planeEl,
				textures: firstTextureGroup,
				planeParentEl,
				groupName,
			});
		});
	}
}
